<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.032.032h19.936v19.936H.032V.032z" />
    <path
      d="M19.968.032s-7.476 0-13.29 5.814c-.25.25-.499.582-.748.832-.997-.084-2.576 0-3.406.747C.697 9.335.032 12.492.032 12.492l4.154-.58v1.41l2.492 2.492h1.41l-.58 4.154s3.157-.665 5.067-2.492c.747-.83.831-2.41.747-3.406.25-.25.583-.498.832-.748C19.968 7.508 19.968.032 19.968.032zm-6.646 4.984c.915 0 1.662.747 1.662 1.662 0 .913-.747 1.66-1.662 1.66-.913 0-1.66-.747-1.66-1.66 0-.915.747-1.662 1.66-1.662zm-9.801 9.138c-.332.083-.581.25-.83.498-1.164 1.08-.997 3.654-.997 3.654s2.492.167 3.654-.996c.249-.25.415-.499.498-.83l-.414-.416c0 .084 0 .166-.084.166-.83.83-1.994.416-1.994.416s-.414-1.163.416-1.994c0-.084.082-.084.166-.084l-.415-.414z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
